var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"olMap",staticStyle:{"width":"100%","height":"450px"},attrs:{"tabindex":"1"}},[_c('div',{attrs:{"id":"features-controls-slot"}},[_vm._t("featureControls")],2),_vm._t("popup")],2)}
var staticRenderFns = []

export { render, staticRenderFns }